@use "sass:string";
@use "../../styles/breakpoint.module.scss" as *;

.panel {
    grid-column: 2 / span 10;
    // Media and text split the row; a lone child fills it
    display: flex;
    gap: var(--spacer-80);
    align-items: flex-start;
    padding: var(--spacer-120) var(--spacer-40);

    @media ($below-tablet) {
        grid-column: 1 / -1;
        flex-direction: column;
        align-items: stretch;
        gap: var(--spacer-24);
        padding: var(--spacer-32) var(--spacer-24);
    }
}

.media {
    flex: 43 1 0;
    min-width: 0;

    @media ($below-tablet) {
        flex: none;
    }

    img,
    video {
        width: 100%;
        height: auto;
        display: block;
        object-fit: cover;
    }
}

.text {
    flex: 57 1 0;
    min-width: 0;

    @media ($below-tablet) {
        flex: none;
    }
}

:export {
    sizes: string.unquote("(min-width: #{$tablet}) 40vw, 90vw");
    sizesFull: string.unquote("(min-width: #{$tablet}) 80vw, 90vw");
}
